import type {
  VesselCardBalticBenchmark,
  VesselCardBalticIndex,
  VesselCardBalticIndexOption,
} from "../models/vessel-card.models";

export const VESSEL_CARD_BALTIC_INDEX_OPTIONS: VesselCardBalticIndexOption[] = [
  { value: "BCI", label: "BCI 182", description: "Capesize 182,000 DWT · ECO: 12 kn; FULL: 14 kn" },
  {
    value: "BCI_180",
    label: "BCI 180",
    description: "Capesize 180,000 DWT · Legacy benchmark",
  },
  { value: "BPI", label: "BPI 82", description: "Panamax 82,500 DWT" },
  { value: "BSI_NEW", label: "BSI 63", description: "Supramax 63,500 DWT · ECO: 12 kn; FULL: 14 kn" },
  { value: "BSI_OLD", label: "BSI 58", description: "Supramax 58,328 DWT · Legacy benchmark" },
  { value: "BHSI", label: "BHSI 38", description: "Handysize 38,200 DWT" },
];

// Starts with the Panamax comparison shown in the requested vessel-card design.
export const VESSEL_CARD_BALTIC_DEFAULT_INDEX: VesselCardBalticIndex = "BPI";

// Scales the vessel's expected consumption to the selected benchmark ship's speed.
export const VESSEL_CARD_BALTIC_CONSUMPTION_EXPONENT = 2.8;

export const VESSEL_CARD_BALTIC_COMPARISON_MODES = ["Ballast ECO", "Laden ECO", "Ballast FULL", "Laden FULL"];

// Uses the six Baltic benchmark ships and ECO/FULL points confirmed by Athul for work item 419805.
// Source: https://dev.azure.com/cargill-teamservices/OT_Data_Platform/_workitems/edit/419805#14851759
// All consumption values are tonnes per day with diesel/MGO excluded.
// Retains the existing selection keys while showing the confirmed ship versions in the dropdown.
export const VESSEL_CARD_BALTIC_BENCHMARKS: Record<VesselCardBalticIndex, VesselCardBalticBenchmark> = {
  BHSI: {
    index: "BHSI",
    rows: [
      { mode: "Ballast ECO", speed: 12, consumption: 17 },
      { mode: "Laden ECO", speed: 12, consumption: 18 },
      { mode: "Ballast FULL", speed: 14, consumption: 24 },
      { mode: "Laden FULL", speed: 14, consumption: 26 },
    ],
  },
  BPI: {
    index: "BPI",
    rows: [
      { mode: "Ballast ECO", speed: 12.5, consumption: 23 },
      { mode: "Laden ECO", speed: 11.5, consumption: 22 },
      { mode: "Ballast FULL", speed: 14, consumption: 31 },
      { mode: "Laden FULL", speed: 13.5, consumption: 33 },
    ],
  },
  BSI_OLD: {
    index: "BSI_OLD",
    rows: [
      { mode: "Ballast ECO", speed: 12.5, consumption: 23 },
      { mode: "Laden ECO", speed: 12, consumption: 24 },
      { mode: "Ballast FULL", speed: 14, consumption: 32 },
      { mode: "Laden FULL", speed: 14, consumption: 33 },
    ],
  },
  BSI_NEW: {
    index: "BSI_NEW",
    rows: [
      { mode: "Ballast ECO", speed: 12, consumption: 17 },
      { mode: "Laden ECO", speed: 12, consumption: 20 },
      { mode: "Ballast FULL", speed: 14, consumption: 25 },
      { mode: "Laden FULL", speed: 14, consumption: 29 },
    ],
  },
  BCI: {
    index: "BCI",
    rows: [
      { mode: "Ballast ECO", speed: 12, consumption: 29 },
      { mode: "Laden ECO", speed: 12, consumption: 36 },
      { mode: "Ballast FULL", speed: 14, consumption: 44 },
      { mode: "Laden FULL", speed: 14, consumption: 52 },
    ],
  },
  BCI_180: {
    index: "BCI_180",
    rows: [
      { mode: "Ballast ECO", speed: 13, consumption: 43 },
      { mode: "Laden ECO", speed: 12, consumption: 43 },
      { mode: "Ballast FULL", speed: 15, consumption: 62 },
      { mode: "Laden FULL", speed: 14, consumption: 62 },
    ],
  },
};
